import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <div className="spinner"></div>
        <h2>Zakim Insurance</h2>
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default Preloader;
